import { render } from "./App.vue?vue&type=template&id=6e9043d8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6e9043d8&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=6e9043d8&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9043d8"]])

export default __exports__